import { toast } from 'react-toastify';

import { axios } from './axios';
import { BOTTOM_TOAST } from '../utils';

export const refreshGladly = async (customerId: string) => {
  try {
    await axios.post(`/accounts/${customerId}/refresh_gladly`);
    toast.success('Gladly profile synced successfully', BOTTOM_TOAST);
  } catch (error) {
    toast.error(`Failed to refresh Gladly profile: ${error}`, BOTTOM_TOAST);
  }
};
